import type { ReactElement } from 'react';
import { useReportWebVitals } from '@/src/homepage/common';
import { HomePageContainer, type HomePageProps } from '@/src/homepage/containers/HomePageContainer';
import {
    HomepageHead,
    getHomepageServerSideProps,
    isLocalePathSupported,
    normalizeTld,
} from '@/src/homepage/components/pages/home';
import { GetServerSidePropsContext } from 'next';
import { getRequestContext } from '@/src/homepage/utils/requestContext';
import { HomepageLayout } from '@/src/homepage/layout/HomepageLayout';
import type { GetLayoutContext } from '@/pages/_app.page';
import { withHomepageDocumentTelemetry } from '@/src/homepage/utils/withHomepageDocumentTelemetry';

export const getServerSideProps = withHomepageDocumentTelemetry(async (context: GetServerSidePropsContext) => {
    const localePathParam = context.params?.locale as string | undefined;

    if (localePathParam) {
        const { tld, host } = getRequestContext(context.req);
        const normalizedTld = normalizeTld(tld);

        if (!isLocalePathSupported(normalizedTld, localePathParam)) {
            return {
                redirect: {
                    destination: `https://${host}/`,
                    permanent: false,
                },
            };
        }
    }

    const handler = getHomepageServerSideProps(localePathParam);
    return handler(context);
});

export function LocaleHome(props: HomePageProps) {
    const { serverUrl } = props.env;
    const { stage } = props;

    useReportWebVitals();
    return (
        <>
            <HomepageHead serverUrl={serverUrl} stage={stage} />
            <HomePageContainer {...props} />
        </>
    );
}

LocaleHome.getLayout = (page: ReactElement, { route }: GetLayoutContext) => (
    <HomepageLayout page={page} route={route} />
);

export default LocaleHome;
